// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form_Form__1f67h","LoadingContent":"Form_LoadingContent__17za5"};